import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Callback from '../views/Callback.vue';
import Privacy from '../views/Privacy.vue';
import InstallExtension from '../views/InstallExtension.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/callback',
		name: 'Callback',
		component: Callback
	},
	{
		path: '/privacy',
		name: 'Privacy',
		component: Privacy
	},
	{
		path: '/install-extension',
		name: 'InstallExtension',
		component: InstallExtension
	}
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
});

export default router;